import { ModuleList } from '../../../shared/analytics/module-list';
import { pagesConfig } from '../../../shared/pages-config';

export const DETAIL_VIEWS_BREADCRUMBS = [
  { label: ModuleList.modules.insights.name },
  {
    label: pagesConfig.insightsDetailViews.name,
    path: `${pagesConfig.insights.link}/${pagesConfig.insightsDetailViews.link}`,
  },
];
